var fn = function( obj ){
var __t,__p='';
__p+='uniform vec4 uColor;\n\n// varying vec2 vTexCoord;\n\nvoid main(void){\n\n  gl_FragColor = vec4(uColor);\n  \n}';
return __p;
};
fn.toString=fn;
module.exports = fn;